<template>
    <div class="forecast">
        <ul class="list pa3 mt2 mb0">
            <ForecastItem v-for="fcItem in forecast" :key="fcItem.time" :forecastItem="fcItem"/>
        </ul>
    </div>
</template>

<script>
import ForecastItem from '@/components/ForecastItem.vue';

export default {
    name: 'Forecast',
    components: {
        ForecastItem,
    },
    props: {
        forecast: Array,
    },
};
</script>

<style scoped>

</style>
